import { useContext } from "react";
import AuthContext from "../../pages/routing/providers/auth/auth.context";

const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

export default useAuth;
